import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { KLM } from '../data/airlinesData';

export default function KlmPage() {
  return <AirlineDetailPage airline={KLM} />;
}
